import CircleStyle from "ol/style/Circle";
import {Fill, Icon, Stroke, Style, Text} from "ol/style";
import {StyleLike} from "ol/style/Style";
import {FlatStyleLike} from "ol/style/flat";
import {FeatureLike} from "ol/Feature";

// IMAGES

const circleErrorImage = new CircleStyle({
  radius: 5, stroke: new Stroke({color: '#fff', width: 1}), fill: new Fill({color: 'red'})
});
const circleImage = new CircleStyle({
  radius: 5, stroke: new Stroke({color: '#fff', width: 1}), fill: new Fill({color: 'green'})
});
const bagDispenserImage = new Icon({
  anchor: [0.5, 37], anchorXUnits: 'fraction', anchorYUnits: 'pixels', src: '/icons/map/bag_dispenser.png',
})
const dogToiletImage = new Icon({
  anchor: [0.5, 37], anchorXUnits: 'fraction', anchorYUnits: 'pixels', src: '/icons/map/dog_toilet.png',
})

const waterFountainImage = new Icon({
  anchor: [0.5, 37], anchorXUnits: 'fraction', anchorYUnits: 'pixels', src: '/icons/map/waterwellpump.png',
})

const dogParkImage = new Icon({
  anchor: [0.5, 37], anchorXUnits: 'fraction', anchorYUnits: 'pixels', src: '/icons/map/citysquare.png',
})
const hereImage = new Icon({
  anchor: [0.5, 37], anchorXUnits: 'fraction', anchorYUnits: 'pixels', src: '/icons/map/here.png',
})

// TYPE STYLES
const typeStyleCache: any = {
  'bag_dispenser': new Style({
    image: bagDispenserImage
  }),
  'dog_toilet': new Style({
    image: dogToiletImage
  }),
  'water_fountain': new Style({
    image: waterFountainImage
  }),
  'dog_park': new Style({
    image: dogParkImage
  }),
  'here': new Style({
    image: hereImage
  }),
  'error': new Style({
    image: circleImage
  })
};

function createTypeStyle(type: string) {
  return typeStyleCache[type] || typeStyleCache['error']
}

function getTypeStyle(type: string | undefined) {
  if (!type) {
    return Styles['PointError']
  }

  if (!typeStyleCache[type]) {
    createTypeStyle(type);
  }
  return typeStyleCache[type];
}

const clusterStyleFunction: StyleLike | FlatStyleLike = function (feature: FeatureLike): any {
  const size = feature.get('features').length;
  if (size > 1) {
    let style = styleCache[size];
    if (!style) {
      style = new Style({
        image: new CircleStyle({
          radius: 10,
          stroke: new Stroke({
            color: '#fff',
          }),
          fill: new Fill({
            color: '#3399CC',
          }),
        }),
        text: new Text({
          text: size.toString(),
          fill: new Fill({
            color: '#fff',
          }),
        }),
      });
      styleCache[size] = style;
    }
    return style
  } else {
    return getTypeStyle(feature.get('features')[0].get("place_type"));
  }
};


// SHAPE STYLES
const styleCache: any = {};
const shapeStyleFunction: StyleLike | FlatStyleLike = function (feature: FeatureLike): any {
  const geo = feature.getGeometry()
  if (!geo) {
    return Styles['PointError']
  }

  return getTypeStyle(feature.get("place_type"))
};


// -----------------------

const Styles: any = {
  'PointError': new Style({
    image: circleErrorImage,
  }),

  'Point': new Style({
    image: circleImage,
  }), 'LineString': new Style({
    stroke: new Stroke({
      color: 'green', width: 1,
    }),
  }), 'MultiLineString': new Style({
    stroke: new Stroke({
      color: 'green', width: 1,
    }),
  }), 'MultiPoint': new Style({
    image: circleImage,
  }), 'MultiPolygon': new Style({
    stroke: new Stroke({
      color: 'yellow', width: 1,
    }), fill: new Fill({
      color: 'rgba(255, 255, 0, 0.1)',
    }),
  }), 'Polygon': new Style({
    stroke: new Stroke({
      color: 'blue', lineDash: [4], width: 3,
    }), fill: new Fill({
      color: 'rgba(0, 0, 255, 0.08)',
    }),
  }), 'GeometryCollection': new Style({
    stroke: new Stroke({
      color: 'magenta', width: 2,
    }), fill: new Fill({
      color: 'magenta',
    }), image: new CircleStyle({
      radius: 10, // fill: null,
      stroke: new Stroke({
        color: 'magenta',
      }),
    }),
  }), 'Circle': new Style({
    stroke: new Stroke({
      color: 'red', width: 2,
    }), fill: new Fill({
      color: 'rgba(255,0,0,0.2)',
    }),
  }),
};

export {
  Styles,
  clusterStyleFunction,
  shapeStyleFunction
}
